import CountryPageRenderer from '../components/CountryPageRenderer';
import latviaData from '../data/country-pages/latvia';

export default function LatviaCountryPage() {
  return <CountryPageRenderer data={latviaData} />;
}
